module.exports = new __parcel__URL__("team-two-people-with-plus.5493a468.svg").toString();